import React from 'react';
import FileButton from '../components/basicComponents/FileButton';

function Documentation({
	portal,
	colors,
	translate,
}) {
	return (
		<div
			id='Documentation'
			className='flex flex-col max-w-screen-2xl md:mx-auto lg:pl-16 lg:pr-16 md:pl-10 md:pr-10 pb-10font-lato mx-6 my-9 text-xs space-y-3 md:my-20 md:text-base md:space-y-6'
		>
			{portal?.attachments.map(file => (
				<FileButton
					colors={colors}
					key={file.id}
					file={file}
					translate={translate}
					text={portal?.config?.labels[file.id]} />
			))}
		</div>
	);
}

export default Documentation;
